import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "text-white" }, "Введите данные для входа", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!

  return (_openBlock(), _createBlock(_component_q_page_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_page, { class: "q-layout-container column justify-center items-center bg-dark" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_q_form, {
            onSubmit: _ctx.submit,
            class: "login-form column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_input, {
                outlined: "",
                label: "E-mail",
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                type: "email",
                error: _ctx.error,
                filled: ""
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_q_input, {
                outlined: "",
                class: "q-mt-xs",
                label: "Пароль",
                filled: "",
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                type: "password",
                error: _ctx.error,
                "error-message": "Неверный e-mail или пароль"
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_q_btn, {
                class: "col self-end",
                label: "Войти",
                "no-caps": "",
                unelevated: "",
                type: "submit",
                color: "secondary",
                loading: _ctx.loading
              }, null, 8, ["loading"])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}